import React, { Component } from 'react';
import { connect } from 'react-redux';
import MarketingPreferences from '../../about-you/marketing-preferences';
import { Modal } from "react-bootstrap";
import { actions, Form } from "react-redux-form";
import { acceptMarketing } from '../../../actions/user';
import { Button } from "react-bootstrap";

const USER_FORM = 'deep.about_you.marketing_consent';

class MarketingConsentPopup extends Component {
  componentDidMount() {
    const { popupActive } = this.props;

    popupActive(true);
  }

  componentWillUnmount() {
    const { popupActive } = this.props;

    popupActive(false);
  }

  submitDisabled() {
    const { formData } = this.props;

    if (formData.marketing_accepted === 'true') {
      return false;
    }

    if (formData.marketing_accepted_confirm !== null) {
      return false;
    }

    return true;
  }

  prepareData() {
    const { formData } = this.props;

    if (formData.marketing_accepted === 'true') {
      return { marketing_accepted: 'true' };
    }

    return { marketing_accepted: formData.marketing_accepted_confirm };
  }

  handleSubmit() {
    const { dispatch } = this.props;

    dispatch(actions.submitFields(USER_FORM, acceptMarketing(this.prepareData(), dispatch)));
  }

  render() {
    const { show, formData } = this.props;

    return (
      <div className="modal-container">
        <Form model={USER_FORM} onSubmit={this.handleSubmit.bind(this)}>
          <Modal
            show={show}
            container={this}
            aria-labelledby="contained-modal-title">
            <Modal.Header>
              <Modal.Title>Update your preferences</Modal.Title>
            </Modal.Header>
            <Modal.Body className="modal-body">
              <MarketingPreferences type="popup" formData={formData} />
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle="primary"
                      type="submit"
                      className="red-ghost-btn float-right"
                      onClick={this.handleSubmit.bind(this)}
                      disabled={this.submitDisabled()}>Submit and continue
              </Button>
            </Modal.Footer>
          </Modal>
        </Form>
      </div>
    )
  };
}

export default connect((state) => ({
  formValid: state.deep.forms.about_you.marketing_consent.$form.valid,
  formData: state.deep.about_you.marketing_consent,
}))(MarketingConsentPopup);



// WEBPACK FOOTER //
// ./src/components/common/marketing/marketing-consent-popup.jsx